import UPDATE_COLLECTION_COVER_MUTATION from 'Root/Pages/Collection/Edit/Type/update-collection.graphql'

import React, { ReactNode, useRef, useState } from 'react'

import { UpdateCollection } from 'globalTypes'

import { useMutation } from '@apollo/client'
import { library } from '@fortawesome/fontawesome-svg-core'
import { faPencil } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import Button from 'Root/App/Button'
import { FileInCloud } from 'Root/App/Form/Upload'
import useUpload from 'lib/use-upload'

library.add(faPencil)

const uploadedCoverInitialValues: FileInCloud = {
  content: null,
  isImage: false,
  uploaded: undefined,
  url: '',
}

const UpdateCover = ({ children, id }: { children: ReactNode; id: string }) => {
  const [mutate] = useMutation<UpdateCollection>(
    UPDATE_COLLECTION_COVER_MUTATION,
    {
      refetchQueries: ['CollectionPageContents'],
      awaitRefetchQueries: true,
    }
  )
  const [inputCoverFile, setInputCoverFile] = useState<FileInCloud>(
    uploadedCoverInitialValues
  )
  const selectFileInput = useRef(null)
  const { loading } = useUpload(inputCoverFile, 'collection/cover', (url) => {
    mutate({ variables: { id, input: { cover: url } } }).then(() => {
      setInputCoverFile({ ...inputCoverFile, url: url, uploaded: true })
    })
  })

  const handleOnChange = (e) => {
    const file = e.target.files[0]

    setInputCoverFile({ ...inputCoverFile, content: file, uploaded: false })
  }

  return (
    <span className="relative">
      <span
        className={
          loading || inputCoverFile.uploaded === false
            ? 'block animate-pulse bg-gray-100 bg-opacity-10'
            : undefined
        }
      >
        {children}
      </span>
      <Button
        className="bg-gray-200 absolute bottom-0 right-0 mr-3 mb-3"
        icon={
          <FontAwesomeIcon
            className="text-sm text-gray-500"
            icon={['fas', 'pencil']}
          />
        }
        subtype="circle"
        disabled={loading || inputCoverFile.uploaded === false}
        onClick={() => selectFileInput.current.click()}
      />

      <input
        accept="image/avif, image/gif, image/jfif, image/jpe, image/jpg, image/jpeg, image/png, image/svg, image/webp"
        className="hidden"
        onChange={handleOnChange}
        ref={selectFileInput}
        type="file"
      />
    </span>
  )
}

export default UpdateCover
